import React, { Component } from 'react';
import './button-dynamic.scss';

//Colors: default(primary), blue, green, orange, black;
//Icons: home, plus, transactions, users;
//Size: full, fit;
export default class ButtonDynamic extends Component {

  renderSimple = (definedClass, children) => {
    const { tooltip } = this.props;
    return (
      <button data-tip={tooltip ? tooltip : null} className={definedClass}  >
        <span>{children ? children : "Botão"}</span>
      </button>
    );
  }


  defineStyle() {
    const { disabled, color, icon, iconDiv } = this.props;
    let definedClass = "";
    if (!disabled) {
      definedClass = color ? `bd-colored-button bd-color-${color}` : `bd-simple-button`;
    } else {
      definedClass = color ? `bd-colored-button bd-color-disabled` : `bd-simple-button  bd-color-disabled`;
    }
    definedClass += icon ? " bd-icon icon-" + icon : " bd-not-icon";
    if (icon && iconDiv) definedClass += " bd-icon-divider";
    return definedClass;
  }


  render() {
    const { size, disabled, children, actionClick, style } = this.props;

    var finalSize = size;

    if (!finalSize) finalSize = "fit";
    let definedClass = this.defineStyle();

    return (
      <div style={style} onClick={!disabled ? actionClick : () => { }} className={disabled ? `rdp-admin-button-dynamic bd-size-${finalSize} bd-d-disabled` : `rdp-admin-button-dynamic bd-size-${finalSize} bd-d-enabled`}  >
        {this.renderSimple(definedClass, children)}

      </div>
    );
  }
}
